module.exports = __webpack_public_path__ + "img/sixpackcarrier10.61756808.jpg";